import styled from "styled-components";

export const Container = styled.div`
  width: 90%;
  max-width: 1100px;
  margin: 10px auto;

  background: #ffffff;
`;

export const Field = styled.div`
  width: 100%;
  margin-top: 15px;
  display: block;
`;

export const InlineField = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  div + div {
    margin-left: 10px;
  }
`;

export const CheckBoxField = styled(Field)`
  display: flex;
  align-items: center;

  div {
    margin-left: 15px !important;

    label {
      padding-left: 20px !important;
    }
  }
`;

export const Title = styled.h1`
  width: 100%;

  margin: 15px auto 15px auto;
  padding-bottom: 5px;

  color: #000000;

  border-bottom: 1px solid rgba(0, 0, 0, 0.15);

  font-size: 28px;
  font-family: sans-serif;
  font-weight: 600;
`;

export const Label = styled.label`
  color: ${(props) => `${props.color}`};

  font-size: 12px;
  font-family: sans-serif;
  font-weight: 600;
`;

export const Input = styled.input`
  width: 100%;
  height: 35px;
  margin: 0;
  padding: 0.67857143em 1em;
  outline: 0;
  background: #ffffff;
  color: rgba(0, 0, 0, 0.87);
  font-size: 13px;
  font-family: sans-serif;
  font-weight: 400;
  border: 1px solid rgba(34, 36, 38, 0.15);
  border-radius: 4px;
  -webkit-appearance: none;
  box-shadow: 0 0 0 0 transparent inset;
  transition: color 0.1s ease, border-color 0.1s ease;
`;

export const InputFile = styled(Input)`
  height: 45px;
`;

export const Select = styled.select`
  width: 100%;
  height: 35px;
  /* margin:0;
  padding: .67857143em 1em;
  outline:0;
  background:#FFFFFF;
  color:rgba(0,0,0,.87);
  font-size:13px;
  font-family:sans-serif;
  font-weight:400;
  border:1px solid rgba(34,36,38,.15);
  border-radius:4px;
  -webkit-appearance:none;
  box-shadow: 0 0 0 0 transparent inset;
  transition: color .1s ease,border-color .1s ease; */
`;

export const Textarea = styled.textarea`
  width: 100%;
  height: 110px;
  margin: 0;
  padding: 0.67857143em 1em;
  outline: 0;
  background: #ffffff;
  color: rgba(0, 0, 0, 0.87);
  font-size: 13px;
  font-family: sans-serif;
  font-weight: 400;
  border: 1px solid rgba(34, 36, 38, 0.15);
  border-radius: 4px;
  -webkit-appearance: none;
  box-shadow: 0 0 0 0 transparent inset;
  transition: color 0.1s ease, border-color 0.1s ease;
`;

export const InputFileEdit = styled.input`
  width: 11% !important;
  height: 30px;
  padding: 0px !important;
  border: 0 !important;
  display: block;

  margin-top: 10px !important;

  &::-webkit-file-upload-button {
    visibility: hidden;
  }

  &::before {
    content: "Escolha arquivo";
    display: inline-block;
    background: linear-gradient(top, #f9f9f9, #e3e3e3);
    border: 1px solid #999;
    border-radius: 3px;
    padding: 5px 8px;
    outline: none;
    white-space: nowrap;
    -webkit-user-select: none;
    cursor: pointer;
    text-shadow: 1px 1px #fff;
    font-weight: 700;
    font-size: 10pt;
  }

  &:hover::before {
    border-color: black;
  }

  &:active::before {
    background: -webkit-linear-gradient(top, #e3e3e3, #f9f9f9);
  }
`;

export const Button = styled.button`
  width: ${(props) => props.width || "130px"};
  height: 35px;

  margin-top: 10px;

  background: rgba(0, 0, 0, 0.87) !important;
  color: #ffffff;

  font-size: 14px;
  font-weight: 600;

  border: 0px;
  border-radius: 5px;

  display: block;

  cursor: pointer;
  transition: all 0.5s;

  &:hover {
    background: rgba(0, 0, 0, 0.7);
  }
`;

export const Error = styled.span`
  color: red;
`
